// Libraries
import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

/**
 * A helper directive to focus buttons. You will only need this if using a custom template.
 */
@Directive({
  selector: '[wpFocus]'
})
export class FocusDirective implements OnChanges {
  /**
   * Focus flag.
   */
  @Input() wpFocus: boolean;

  constructor(private elm: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.wpFocus && this.wpFocus === true) {
      this.elm.nativeElement.focus();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/woopa-ui/confirmation-popover/focus.directive.ts